import React from 'react';
import { Grid, Typography, Box, Avatar, Paper } from '@mui/material';

import { FiMessageCircle } from 'react-icons/fi';

import ChatBot from 'react-simple-chatbot';

import ReactPlayer from 'react-player/lazy'

export default function SuportePage() {

  const steps = [
    {
      id: '0',
      message: 'Como posso te ajudar?',
      trigger: '4',
    },
     {
      id: '4',
      options: [
        { value: 1, label: 'Inserir Produto', trigger: 'P01:1' },
        { value: 2, label: 'CPF Invalido', trigger: 'P02' },
        { value: 3, label: 'Alterar Pedido', trigger: 'P03' },
        { value: 4, label: 'Problema com Maquininha', trigger: 'P04' },
        { value: 5, label: 'Duvidas com Faturamento', trigger: 'P05' },
        { value: 6, label: 'Preco divergente', trigger: 'P03:2' },
        { value: 9, label: 'Loja que esta o produto nao atende', trigger: 'P09' },
      ],
    },
    {
      id: 'P01:1',
      message: 'Qual o reduzido?',
      trigger: 'P01:2',
    },
    {
        id: 'P01:2',
        user: true,
        inputAttributes: {
        keyboardType: 'default'
      },
      trigger: 'P01:3',
      },
      {
        id: 'P01:3',
        message: 'Selecione a cor',
        trigger: 'P01:3:1',
      },
      {
        id: 'P01:3:1',
        options: [
          { value: 1, label: 'Preto', trigger: 'produto_inserido_com_sucesso' },
          { value: 2, label: 'Branco', trigger: 'produto_inserido_com_sucesso' },
        ],
      },
      {
        id: 'produto_inserido_com_sucesso',
        message: 'Produto Inserido com sucesso',
        trigger: 'final',
      },
      {
        id: 'P02',
        message: 'O Sistema tem uma validacao de CPF para que possa ser feita a venda. Se aparecer a mensagem de CPF INVALIDO, esse cpf nao existe',
        trigger: 'final',
      },
      {
        id: 'P03',
        options: [
          { value: 1, label: 'Alterar Produto', trigger: 'P03:1' },
          { value: 2, label: 'Alterar Preco de produto', trigger: 'P03:2' },
          { value: 3, label: 'Alterar cor do pedido', trigger: 'P03:3' },
          { value: 4, label: 'Alterar numeracao', trigger: 'P03:3' }
        ],
      },
      {
        id: 'P03:1',
        message: 'O painel de gerencimento de pedidos ainda esta em desenvolvimento',
        trigger: 'P03:1:1',
      },
      {
        id: 'P03:1:1',
        message: 'Refaca o pedido novamente',
        trigger: 'P03:2',
      },
      {
        id: 'P03:2',
        message: 'O preco no Venda Facil esta mais caro que na sua loja?',
        trigger: 'P03:2:1',
      },
      {
        id: 'P03:2:1',
        options: [
          { value: 1, label: 'Sim', trigger: 'P03:2:1:1' },
          { value: 2, label: 'Nao', trigger: 'P03:2:1:2' },
        ],
      },
      {
        id: 'P03:2:1:1',
        message: 'O painel de gerencimento de pedidos ainda esta em desenvolvimento',
        trigger: 'P03:2:1:1:1',
      },
      {
        id: 'P03:2:1:1:1',
        message: 'Entre em contato com o setor para alteracao do preco e prosseguimento da venda',
        trigger: 'final',
      },
      {
        id: 'P03:2:1:2',
        message: 'Conforme alianhado com a diretoria, foi definido que mantera o preco mais barato na filial que ira faturar',
        trigger: 'final',
      },
      {
        id: 'P03:3',
        message: 'O painel de gerencimento de pedidos ainda esta em desenvolvimento',
        trigger: 'P03:3:1',
      },
      {
        id: 'P03:3:1',
        message: 'Refaca o pedido novamente',
        trigger: 'final',
      },
      {
        id: 'P04',
        message: 'Qual mensagem aparece na tela do COMPUTADOR da pagina pagamento.katuxa.com.br ?',
        trigger: 'P04:1',
      },
      {
        id: 'P04:1',
        options: [
          { value: 1, label: 'Servidor Desconectado', trigger: 'P04:1:1' },
          { value: 2, label: 'Processando Pagamento', trigger: 'P04:1:2' },
          { value: 3, label: 'Nao foi possivel conectar ao Zoop', trigger: 'P04:1:3' },
        ],
      },
      {
        id: 'P04:1:1',
        asMessage: true,
        component: <ReactPlayer width={300} url='https://www.youtube.com/watch?v=ysz5S6PUM-U' />,
        trigger: 'final',
      },
      {
        id: 'P04:1:2',
        asMessage: true,
        component: <ReactPlayer width={300} url='https://www.youtube.com/watch?v=ysz5S6PUM-U' />,
        trigger: 'final',
      },
      {
        id: 'P04:1:3',
        message: 'Entre em contato com o setor, possivelmente esse e um problema de bloqueio da Zoop com a rede da Katuxa',
        trigger: 'final',
      },
      {
        id: 'P05',
        message: 'Veja o video abaixo do processo de faturamento de nota fiscal do Venda Facil',
        trigger: 'P05:1',
      },
      {
        id: 'P05:1',
        asMessage: true,
        component: <ReactPlayer width={300} controls={true} url='https://player.vimeo.com/video/702971401?h=6add20be08' />,
        trigger: 'final',
      },
      {
        id: 'final',
        message: 'Te ajudo em algo mais?',
        trigger: 'final:1'
      },
      {
        id: 'final:1',
        options: [
          { value: 1, label: 'Sim', trigger: '0' },
          { value: 2, label: 'Nao', trigger: 'final:2' },
        ],
      },
      {
        id: 'final:2',
        message: 'Se precisar e chamar!',
        trigger: 'final:3'
      },
      {
        id: 'final:3',
        options: [
          { value: 1, label: 'Menu', trigger: '0' },
        ],
      },
      {
        id: 'P09',
        message: 'Vamos pedir para que entre em contato com o supervisor responsavel Osmar e relate o ocorrido para que possa tomar',
        trigger: 'P09:1',
      },
      {
        id: 'P09:1',
        message: 'Numero: 37 9139-2211 e relate o ocorrido para que possa tomar as devidas providencias',
        trigger: 'final',
      },
  ];

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5', maxWidth: '98%', mx: 'auto' }}>
        <Box sx={{ py: 2.5, px: { xs: 2, md: 3 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
              <FiMessageCircle size={18} />
            </Avatar>
            <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
              Suporte
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={10} lg={8}>
            <Paper sx={{
              p: { xs: 2.5, md: 3 },
              borderRadius: 2.5,
              border: '1px solid',
              borderColor: 'grey.200',
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              bgcolor: '#fff',
              overflow: 'hidden'
            }}>
              <ChatBot
                width="100%"
                botDelay={500}
                headerTitle={"Fale com a Katia, a IA da Katuxa"}
                placeholder={"Digite aqui a sua mensagem"}
                hideHeader={true}
                bubbleStyle={{ backgroundColor: "#1a1a2e", color: "#fff", fontFamily: 'Montserrat', fontWeight: '600' }}
                steps={steps}
              />
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
